import { render, staticRenderFns } from "./ChartShippingCost.vue?vue&type=template&id=cef6ad76&"
import script from "./ChartShippingCost.vue?vue&type=script&lang=js&"
export * from "./ChartShippingCost.vue?vue&type=script&lang=js&"
import style0 from "./ChartShippingCost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports